/* Legacy → canonical project slug aliases.
 *
 * The original slugs encoded NDA client names in public URLs (Srinath's
 * security ruling, 2026-06-11: rename, keep old ids resolving). Old links —
 * bookmarks, crawler caches, shared URLs — 301-style redirect to the neutral
 * canonical slug. Never link to the legacy ids from the UI.
 */
export const PROJECT_SLUG_ALIASES: Record<string, string> = {
  "barclays-investment-bank": "global-investment-bank-uk",
  "travelers-ccaas-enablement": "pc-insurer-ccaas-enablement",
  "apple-contact-lens-analytics": "consumer-tech-contact-lens-analytics",
};

export function canonicalProjectId(id: string): string {
  return PROJECT_SLUG_ALIASES[id] ?? id;
}
